<div style="display:none;">
<div id="carouselExampleControls" class="carousel slide" data-ride="carousel" style="display:none;">
    <div class="carousel-inner">
      <div class="carousel-item active" *ngFor="let banner of bannerUrl">
        <img class="d-block w-100 banner-height" [src]="banner.path" alt="First slide">
      </div>
<!--      <div class="carousel-item">-->
<!--        <img class="d-block w-100 banner-height" [src]="bannerUrl" alt="Second slide">-->
<!--      </div>-->
<!--      <div class="carousel-item">-->
<!--        <img class="d-block w-100 banner-height" [src]="bannerUrl" alt="Third slide">-->
<!--      </div>-->
    </div>
    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</div>